"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecimalField2 = void 0;
const react_1 = __importStar(require("react"));
const react_number_format_1 = __importDefault(require("react-number-format"));
const lodash_1 = require("lodash");
const locale_context_1 = require("../../providers/locale/locale-context");
const text_field_1 = require("../text-field/text-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function DecimalField2({ value = null, onChange: providedOnChange, negative = false, formated = false, maxValue, minValue, decimalDigits = 2, fixedDecimalDigits = true, decimalSeparator, ...textFieldProps }) {
    value = value !== null && value !== void 0 ? value : '';
    const { locale } = (0, react_1.useContext)(locale_context_1.LocaleContext);
    const handleClear = (0, event_callback_hook_1.useEventCallback)((e) => {
        e.stopPropagation();
        providedOnChange('');
    });
    const ComponentWrapper = (0, react_1.useMemo)(() => function ComponentWrapper({ value, onChange, }) {
        return (react_1.default.createElement(text_field_1.TextField, { value: value, onChangeEvent: onChange, form: textFieldProps.form, name: textFieldProps.name, disabled: textFieldProps.disabled, startAdornment: textFieldProps.startAdornment, endAdornment: textFieldProps.endAdornment, error: textFieldProps.error, autocomplete: textFieldProps.autocomplete, type: textFieldProps.type, inputProps: textFieldProps.inputProps, onBlur: textFieldProps.onBlur, onFocus: textFieldProps.onFocus, onKeyDown: textFieldProps.onKeyDown, autoFocus: textFieldProps.autoFocus, onClear: handleClear }));
    }, [
        textFieldProps.form,
        textFieldProps.name,
        textFieldProps.disabled,
        textFieldProps.startAdornment,
        textFieldProps.endAdornment,
        textFieldProps.error,
        textFieldProps.autocomplete,
        textFieldProps.type,
        textFieldProps.inputProps,
        textFieldProps.onBlur,
        textFieldProps.onFocus,
        textFieldProps.onKeyDown,
        textFieldProps.autoFocus,
        handleClear,
    ]);
    const onChange = (0, event_callback_hook_1.useEventCallback)((values, info) => {
        info.source === 'event' && providedOnChange(values.value);
    });
    const isAllowed = (0, event_callback_hook_1.useEventCallback)((values) => {
        if (minValue !== undefined &&
            values.floatValue !== undefined &&
            values.floatValue < minValue) {
            return false;
        }
        if (maxValue !== undefined &&
            values.floatValue !== undefined &&
            values.floatValue > maxValue) {
            return false;
        }
        return true;
    });
    return (react_1.default.createElement(react_number_format_1.default, { onChange: lodash_1.noop, customInput: ComponentWrapper, decimalSeparator: decimalSeparator || locale.decimalSeparator, decimalScale: decimalDigits, fixedDecimalScale: fixedDecimalDigits, allowNegative: negative, value: value, isAllowed: isAllowed, onValueChange: onChange, isNumericString: true }));
}
exports.DecimalField2 = DecimalField2;
//# sourceMappingURL=decimal-field2.js.map